import React, { useEffect } from 'react';
import { Box, FormHelperText, FormLabel, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { GooglePlacesAutocomplete } from '@/components/selects/GooglePlacesAutocomplete';
import { OwnerSelect } from '@/components/selects/OwnerSelect';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import CompanyTextField from '../CompanyTextField';

const CompanyDetailsFields = ({ disabled = false }) => {
	const { values, setFieldValue, touched, errors } = useFormikContext();
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
	const ownerError = touched.ownerDocId && errors.ownerDocId;

	useEffect(() => {
		if (!values.ownerDocId && userDetails?.userId) {
			setFieldValue('ownerDocId', userDetails.userId);
		}
	}, [setFieldValue, userDetails?.userId, values.ownerDocId]);

	return (
		<Grid container spacing={2} sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
			<Grid size={{ xs: 12, sm: 6 }}>
				<FormLabel required>Company owner</FormLabel>
				<OwnerSelect
					initialId={values.ownerDocId}
					disabled={disabled}
					showGroup
					onChange={(user) => {
						setFieldValue('ownerDocId', user?.id);
					}}
				/>
				{ownerError && <FormHelperText error>{errors.ownerDocId}</FormHelperText>}
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<CompanyTextField name='tradingName' label='Trading name' disabled={disabled} />
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<CompanyTextField name='website' label='Website' disabled={disabled} />
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<CompanyTextField name='phone' label='Company phone' disabled={disabled} />
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<CompanyTextField name='email' label='Company email' disabled={disabled} />
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<CompanyTextField
					name='abn'
					label='ABN / registration number'
					disabled={disabled}
				/>
			</Grid>
			<Grid size={12}>
				<Box>
					<FormLabel>Address</FormLabel>
					<GooglePlacesAutocomplete
						address={values.address}
						error={touched.address && Boolean(errors.address)}
						helperText={touched.address && errors.address}
						disabled={disabled}
						onSelectAddress={(params) => {
							setFieldValue('address', params.addressLine1 ?? '');
							setFieldValue('city', params.city ?? params.suburb ?? '');
							setFieldValue('state', params.state ?? '');
							setFieldValue('postcode', params.postcode ?? '');
							setFieldValue('country', params.country ?? '');
						}}
					/>
					<FormHelperText>Street address</FormHelperText>
				</Box>
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<CompanyTextField name='city' label='City' disabled={disabled} />
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<CompanyTextField name='state' label='State' disabled={disabled} />
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<CompanyTextField name='postcode' label='Postcode' disabled={disabled} />
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }}>
				<CompanyTextField name='country' label='Country' disabled={disabled} />
			</Grid>
			<Grid size={12}>
				<CompanyTextField
					name='industry'
					label='Industry / market segment'
					disabled={disabled}
				/>
			</Grid>
		</Grid>
	);
};

export default CompanyDetailsFields;
